import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';
import notify from 'devextreme/ui/notify';
import { injectSignOut } from '../../auth/commands/sign-out';
import { injectUser } from '../../auth/data/user';
import UserPanel from '../../auth/ui/user-panel/user-panel';

@Component({
  selector: 'app-header',
  imports: [DxButtonModule, UserPanel, DxToolbarModule, NgOptimizedImage],
  templateUrl: './header.html',
  styleUrl: './header.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class Header {
  private readonly router = inject(Router);
  private readonly signOut = injectSignOut();

  readonly menuToggle = output();
  readonly menuToggleEnabled = input(false);
  readonly appTitle = input.required<string>();

  protected readonly user = injectUser();

  protected readonly userMenuItems = [
    {
      text: 'Profile',
      icon: 'user',
      onClick: () => {
        this.router.navigate(['/profile']);
      },
    },
    { text: 'Devices', icon: 'lock', onClick: () => this.router.navigate(['/devices']) },
    {
      text: 'Sign Out',
      icon: 'runner',
      onClick: () => {
        this.signOut();
      },
    },
  ];

  protected readonly toggleMenu = () => {
    this.menuToggle.emit();
  };

  protected readonly onHelpClick = () => {
    notify('Help is coming soon.', 'info', 2000);
  };

  protected readonly onNotificationsClick = () => {
    this.router.navigate(['/notifications']);
  };
}
